module.exports = __webpack_public_path__ + "img/01-top-img.b8a16a65.png";